module.exports = __webpack_public_path__ + "05_face.f5810a9b.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/girl/layer1/05_face.png
// module id = YN+k
// module chunks = 0